import { getData, postData } from "../api/api";
import {
  AssignSubscriptionRequest,
  CancellationRequest,
  PagedModel,
  UserSubscription,
} from "../types/subscription";
import { buildReadQueryString } from "../lib/api/readQuery";

const BASE_URL = "/user-subscription";

const toSearchParam = (search?: string) => {
  const value = String(search || "").trim();
  return value ? `username=ilike=${value}` : "";
};

export const userSubscriptionService = {
  read: async (page: number = 0, size: number = 20, search?: string, fields?: string | string[]) => {
    return getData(
      `${BASE_URL}/read?${buildReadQueryString({
        page,
        size,
        sort: "createdDate,desc",
        search: toSearchParam(search) || undefined,
        fields,
      })}`,
    ) as Promise<PagedModel<UserSubscription>>;
  },

  readById: async (id: string) => {
    return getData(`${BASE_URL}/read/${id}`) as Promise<UserSubscription>;
  },

  mySubscription: async () => {
    return getData(`${BASE_URL}/my`) as Promise<UserSubscription | null>;
  },

  byUsername: async (username: string) => {
    return getData(`${BASE_URL}/by-username?username=${encodeURIComponent(username)}`) as Promise<
      UserSubscription[]
    >;
  },

  assign: async (payload: AssignSubscriptionRequest) => {
    return postData(`${BASE_URL}/assign`, payload) as Promise<UserSubscription>;
  },

  cancel: async (id: string, payload: CancellationRequest) => {
    return postData(`${BASE_URL}/cancel/${id}`, payload) as Promise<UserSubscription>;
  },
};

